import React from 'react'

const SadImage = () => {
  return (
    <>
      <svg width='104' height='104' viewBox='0 0 104 104' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M52 104C23.3274 104 0 80.6726 0 52C0 23.3274 23.3274 0 52 0C80.6726 0 104 23.3274 104 52C104 80.6726 80.6726 104 52 104ZM52 6.5C26.9111 6.5 6.5 26.9111 6.5 52C6.5 77.0889 26.9111 97.5 52 97.5C77.0889 97.5 97.5 77.0889 97.5 52C97.5 26.9111 77.0889 6.5 52 6.5ZM76.2038 74.4077C77.8093 73.6049 78.4604 71.6527 77.6577 70.0472C77.3543 69.4417 70.0516 55.25 52 55.25C33.9484 55.25 26.6457 69.4417 26.3423 70.0462C25.5428 71.6462 26.1896 73.5854 27.7853 74.3925C29.3854 75.1974 31.3333 74.5593 32.149 72.9679C32.3841 72.5097 38.0575 61.75 52 61.75C65.9425 61.75 71.6159 72.5097 71.8423 72.9538C72.4122 74.0935 73.5594 74.7522 74.7533 74.75C75.2408 74.75 75.7369 74.6406 76.2038 74.4077ZM68.25 45.5C64.6653 45.5 61.75 42.5848 61.75 39C61.75 35.4153 64.6653 32.5 68.25 32.5C71.8348 32.5 74.75 35.4153 74.75 39C74.75 42.5848 71.8348 45.5 68.25 45.5ZM35.75 45.5C32.1653 45.5 29.25 42.5848 29.25 39C29.25 35.4153 32.1653 32.5 35.75 32.5C39.3348 32.5 42.25 35.4153 42.25 39C42.25 42.5848 39.3348 45.5 35.75 45.5Z'
          fill='black'
          fill-opacity='0.3'
        />
      </svg>
    </>
  )
}

export default SadImage
